import PopupAlert from 'react-popup'

export default class Alert {
  static alert = (title, content, buttons = null) => {
    let popupButtons = [{
      text: 'Ok',
      className: 'is--rounded is--blue',
      action: PopupAlert.close
    }]

    if (buttons) {
      popupButtons = buttons.map(button => ({
        text: button.text,
        className: `is--rounded ${button.style === 'cancel' ? 'is--white' : 'is--blue'}`,
        action: () => {
          button.onClick && button.onClick()
          PopupAlert.close()
        },
      }))
    }

    PopupAlert.create({
      title,
      content,
      buttons: {
        right: popupButtons
      }
    })
  }
}
